import { useState } from "react";
import { Product } from "@/types/product";
import { useToast } from "@/components/ui/use-toast";
import { ExplorerContent } from "@/components/explorer/ExplorerContent";

const Explorer = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [currentQuery, setCurrentQuery] = useState("");
  const [currentFilters, setCurrentFilters] = useState("");
  const { toast } = useToast();

  const handleProductsFiltered = (filteredProducts: Product[]) => {
    console.log('Filtered products:', filteredProducts.length);
  };

  const handleFilterChange = (filters: string) => {
    setCurrentFilters(filters);
  };

  const handleSearch = (query: string) => {
    setCurrentQuery(query);
  };

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <main className="container py-6 flex-1">
        <h1 className="text-4xl font-bold mb-8 text-center">Data Explorer</h1>
        {isLoading ? (
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-4 border-primary border-t-transparent"></div>
          </div>
        ) : (
          <ExplorerContent 
            onProductsFiltered={handleProductsFiltered}
            onFilterChange={handleFilterChange}
            onSearch={handleSearch}
          />
        )}
      </main>
    </div>
  );
};

export default Explorer;